import { Box, ClickAwayListener, PopperProps, Popper } from '@material-ui/core';
import clsx from 'clsx';
import { CSSProperties, useRef } from 'react';
import { useStyles } from './style';
import SLabel from '../../../../sui/slabel';

interface SSelectDropdownProps
  extends Omit<PopperProps, 'children' | 'open' | 'content'> {
  width?: number;
  anchor: JSX.Element;
  anchorElement?: HTMLElement | null;
  content: JSX.Element;
  placement?: PopperProps['placement'];
  // Refactor to use dropdownOpen instead of anchorElement
  dropdownOpen?: boolean;
  onClose: (e: React.MouseEvent<Document>) => void;
  marginTop?: number;
  className?: string;
  fullWidth?: boolean;
  label?: string;
  // ! This sloud be removed when we migrate whole app new design
  newDesign?: boolean;
  dropdownContainerStyle?: CSSProperties;
}

const SSelectDropdown = ({
  fullWidth = false,
  width,
  anchor,
  anchorElement,
  content,
  placement = 'bottom-end',
  onClose,
  dropdownOpen,
  className = '',
  marginTop = 4,
  label = '',
  newDesign = false,
  dropdownContainerStyle,
  ...rest
}: SSelectDropdownProps) => {
  const classes = useStyles({ width });
  const anchorRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <div
        ref={anchorRef}
        style={{
          ...(fullWidth ? { width: '100%' } : {})
        }}>
        {!!label && (
          <SLabel
            title={label}
            variant="body2"
            style={{
              marginBottom: 8,
              display: 'block'
            }}
          />
        )}

        {anchor}
      </div>
      <Popper
        style={{ marginTop, ...dropdownContainerStyle }}
        className={newDesign ? classes.popperV2 : classes.popper}
        open={anchorElement ? Boolean(anchorElement) : dropdownOpen}
        anchorEl={anchorElement || anchorRef.current}
        placement={placement}
        {...rest}>
        <ClickAwayListener onClickAway={onClose}>
          <Box className={clsx(classes.content, className)}>{content}</Box>
        </ClickAwayListener>
      </Popper>
    </>
  );
};

export default SSelectDropdown;
